module.exports = __webpack_public_path__ + "static/media/SPONSORS (3).6e372dc6.png";